import ActiveRecord from "@/models/ActiveRecord";

export default class Visitor extends ActiveRecord {
  // entity is a required property for all models.
  static entity = "visitor";

  // List of all fields (schema) of the post model. `this.attr()` declares
  // a generic field type with a default value as the first argument.
  static fields() {
    return {
      id: this.uid(() => this.uuidv4()),
      user_id: this.attr(null),
      email: this.attr(null),
      name: this.attr(null),
      customer_id: this.attr(null) //optional field that allows user to provide their own customer id value
    };
  }
}
